import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [searchParams] = useSearchParams();
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [openFAQ, setOpenFAQ] = useState(null);
  const practiceArea = searchParams.get('area') || 'corporate-law';

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const faqData = {
    'corporate-law': {
      en: {
        title: 'Frequently Asked Questions',
        subtitle: 'Common questions about our corporate law services',
        faqs: [
          {
            question: 'What types of business entities can you help me establish?',
            answer: 'We assist with all types of business formations including private limited companies, public companies, partnerships, sole proprietorships, and non-profit organizations. We help you choose the most suitable structure based on your business goals, tax considerations, and operational requirements.'
          },
          {
            question: 'How long does it take to incorporate a company in Kenya?',
            answer: 'Company incorporation in Kenya typically takes 7-14 business days once all required documents are submitted. However, the timeline can vary depending on the complexity of the structure and any additional requirements such as special licenses or permits.'
          },
          {
            question: 'What ongoing compliance requirements do companies have?',
            answer: 'Companies must file annual returns, maintain statutory registers, hold annual general meetings, file tax returns, and comply with industry-specific regulations. We provide ongoing compliance services to ensure your company meets all legal obligations.'
          },
          {
            question: 'Do you handle mergers and acquisitions?',
            answer: 'Yes, we provide comprehensive M&A services including due diligence, transaction structuring, negotiation, regulatory approvals, and closing. Our team has extensive experience in both domestic and cross-border transactions.'
          },
          {
            question: 'What are your fees for corporate law services?',
            answer: 'Our fees vary depending on the complexity and scope of services required. We offer transparent pricing and will provide a detailed fee estimate after understanding your specific needs. We also offer flexible payment arrangements for ongoing services.'
          }
        ]
      },
      sw: {
        title: 'Maswali Yanayoulizwa Mara Kwa Mara',
        subtitle: 'Maswali ya kawaida kuhusu huduma zetu za sheria ya makampuni',
        faqs: [
          {
            question: 'Ni aina gani za mashirika ya biashara mnazoweza kunisaidia kuanzisha?',
            answer: 'Tunasaidia katika aina zote za uundaji wa biashara ikiwa ni pamoja na makampuni ya kibinafsi yenye uwajibikaji mdogo, makampuni ya umma, ushirikiano, umiliki wa mtu mmoja, na mashirika yasiyo ya faida. Tunakusaidia kuchagua muundo unaofaa zaidi kulingana na malengo yako ya biashara, mazingatio ya kodi, na mahitaji ya utendaji.'
          },
          {
            question: 'Inachukua muda gani kuanzisha kampuni nchini Kenya?',
            answer: 'Uundaji wa kampuni nchini Kenya kwa kawaida huchukua siku 7-14 za kazi mara nyaraka zote zinazohitajika zikiwasilishwa. Hata hivyo, ratiba inaweza kutofautiana kulingana na utata wa muundo na mahitaji yoyote ya ziada kama vile leseni maalum au ruhusa.'
          },
          {
            question: 'Ni mahitaji gani ya kufuata sheria yanayoendelea makampuni yana?',
            answer: 'Makampuni lazima yafailie ripoti za kila mwaka, kudumisha daftari za kisheria, kufanya mikutano ya kila mwaka ya jumla, kufailia ripoti za kodi, na kufuata kanuni za sekta maalum. Tunatoa huduma za kufuata sheria zinazoendelea kuhakikisha kampuni yako inakidhi majukumu yote ya kisheria.'
          },
          {
            question: 'Je, mnashughulikia kuunganisha na ununuzi?',
            answer: 'Ndiyo, tunatoa huduma kamili za M&A ikiwa ni pamoja na utafiti wa kina, muundo wa miamala, mazungumzo, idhini za udhibiti, na kufunga. Timu yetu ina uzoefu mkubwa katika miamala ya ndani na ya kimataifa.'
          },
          {
            question: 'Ni ada gani za huduma zenu za sheria ya makampuni?',
            answer: 'Ada zetu zinatofautiana kulingana na utata na upeo wa huduma zinazohitajika. Tunatoa bei wazi na tutakupa makadirio ya kina ya ada baada ya kuelewa mahitaji yako maalum. Pia tunatoa mipango ya malipo ya kubadilika kwa huduma zinazoendelea.'
          }
        ]
      }
    },
    'family-law': {
      en: {
        title: 'Frequently Asked Questions',
        subtitle: 'Common questions about our family law services',
        faqs: [
          {
            question: 'How long does a divorce process take in Kenya?',
            answer: 'The duration of divorce proceedings varies depending on whether it\'s contested or uncontested. Uncontested divorces can take 3-6 months, while contested cases may take 1-2 years or longer depending on the complexity of issues involved.'
          },
          {
            question: 'How is child custody determined?',
            answer: 'Child custody decisions are based on the best interests of the child, considering factors such as the child\'s age, health, emotional ties with parents, stability of home environment, and the parents\' ability to provide care and support.'
          },
          {
            question: 'What factors affect property division in divorce?',
            answer: 'Property division considers the duration of marriage, contributions of each spouse (financial and non-financial), needs of children, standard of living during marriage, and future earning capacity of each spouse.'
          },
          {
            question: 'Can child support orders be modified?',
            answer: 'Yes, child support orders can be modified if there\'s a significant change in circumstances such as changes in income, employment status, or the child\'s needs. A court application is required for modification.'
          },
          {
            question: 'Do you handle adoption cases?',
            answer: 'Yes, we handle both domestic and international adoption cases. We guide clients through the entire adoption process including home studies, legal documentation, court proceedings, and post-adoption requirements.'
          }
        ]
      },
      sw: {
        title: 'Maswali Yanayoulizwa Mara Kwa Mara',
        subtitle: 'Maswali ya kawaida kuhusu huduma zetu za sheria ya familia',
        faqs: [
          {
            question: 'Mchakato wa talaka huchukua muda gani nchini Kenya?',
            answer: 'Muda wa michakato ya talaka unatofautiana kulingana na kama ni ya migogoro au isiyokuwa na migogoro. Talaka zisizo na migogoro zinaweza kuchukua miezi 3-6, wakati kesi za migogoro zinaweza kuchukua miaka 1-2 au zaidi kulingana na utata wa masuala yanayohusika.'
          },
          {
            question: 'Ulinzi wa watoto unamuliwa vipi?',
            answer: 'Maamuzi ya ulinzi wa watoto yanategemea maslahi bora ya mtoto, kuzingatia mambo kama vile umri wa mtoto, afya, uhusiano wa kihisia na wazazi, uthabiti wa mazingira ya nyumbani, na uwezo wa wazazi kutoa huduma na msaada.'
          },
          {
            question: 'Ni mambo gani yanayoathiri mgawanyo wa mali katika talaka?',
            answer: 'Mgawanyo wa mali unazingatia muda wa ndoa, michango ya kila mwenza (ya kifedha na isiyokuwa ya kifedha), mahitaji ya watoto, kiwango cha maisha wakati wa ndoa, na uwezo wa kupata mapato ya baadaye wa kila mwenza.'
          },
          {
            question: 'Je, amri za msaada wa watoto zinaweza kubadilishwa?',
            answer: 'Ndiyo, amri za msaada wa watoto zinaweza kubadilishwa kama kuna mabadiliko makubwa ya mazingira kama vile mabadiliko ya mapato, hali ya ajira, au mahitaji ya mtoto. Ombi la mahakama linahitajika kwa marekebisho.'
          },
          {
            question: 'Je, mnashughulikia kesi za kupokea watoto?',
            answer: 'Ndiyo, tunashughulikia kesi za kupokea watoto za ndani na za kimataifa. Tunaongoza wateja katika mchakato wote wa kupokea watoto ikiwa ni pamoja na masomo ya nyumbani, nyaraka za kisheria, michakato ya mahakama, na mahitaji ya baada ya kupokea.'
          }
        ]
      }
    },
    'property-law': {
      en: {
        title: 'Frequently Asked Questions',
        subtitle: 'Common questions about our property law services',
        faqs: [
          {
            question: 'What documents do I need for property purchase?',
            answer: 'Key documents include the title deed, survey plan, valuation report, search certificate, rates clearance certificate, and consent to transfer from relevant authorities. We conduct comprehensive due diligence to verify all documentation.'
          },
          {
            question: 'How long does property transfer take?',
            answer: 'Property transfer typically takes 30-60 days from the date of signing the sale agreement, depending on the efficiency of government offices and any complications that may arise during the process.'
          },
          {
            question: 'What are the costs involved in property transactions?',
            answer: 'Costs include stamp duty (4% of property value), legal fees, registration fees, valuation fees, and search fees. We provide a detailed breakdown of all costs before proceeding with any transaction.'
          },
          {
            question: 'Can foreigners own property in Kenya?',
            answer: 'Foreigners can own property in Kenya but with certain restrictions. They can own apartments and commercial properties but cannot own agricultural land. We advise on the best ownership structures for foreign investors.'
          },
          {
            question: 'What should I do if there\'s a property dispute?',
            answer: 'Property disputes should be addressed immediately. We help with negotiation, mediation, and if necessary, litigation to resolve disputes related to boundaries, ownership, tenancy, or other property matters.'
          }
        ]
      },
      sw: {
        title: 'Maswali Yanayoulizwa Mara Kwa Mara',
        subtitle: 'Maswali ya kawaida kuhusu huduma zetu za sheria ya mali',
        faqs: [
          {
            question: 'Ni nyaraka gani ninazohitaji kwa ununuzi wa mali?',
            answer: 'Nyaraka muhimu ni pamoja na hati ya umiliki, mpango wa upimaji, ripoti ya uthamini, cheti cha utafutaji, cheti cha uongozi wa kodi, na idhini ya uhamisho kutoka mamlaka husika. Tunafanya utafiti wa kina kuhakikisha nyaraka zote.'
          },
          {
            question: 'Uhamisho wa mali huchukua muda gani?',
            answer: 'Uhamisho wa mali kwa kawaida huchukua siku 30-60 kutoka tarehe ya kutia saini mkataba wa mauzo, kulingana na ufanisi wa ofisi za serikali na matatizo yoyote yanayoweza kutokea wakati wa mchakato.'
          },
          {
            question: 'Ni gharama gani zinazohusika katika miamala ya mali?',
            answer: 'Gharama ni pamoja na ada ya muhuri (4% ya thamani ya mali), ada za kisheria, ada za usajili, ada za uthamini, na ada za utafutaji. Tunatoa mgawanyo wa kina wa gharama zote kabla ya kuendelea na muamala wowote.'
          },
          {
            question: 'Je, wageni wanaweza kumiliki mali nchini Kenya?',
            answer: 'Wageni wanaweza kumiliki mali nchini Kenya lakini kwa vikwazo fulani. Wanaweza kumiliki vyumba na mali za kibiashara lakini hawawezi kumiliki ardhi ya kilimo. Tunashauri kuhusu miundo bora ya umiliki kwa wawekezaji wa kigeni.'
          },
          {
            question: 'Nifanye nini kama kuna ugomvi wa mali?',
            answer: 'Migogoro ya mali inapaswa kushughulikiwa mara moja. Tunasaidia katika mazungumzo, upatanisho, na ikiwa ni lazima, mashtaka kutatua migogoro inayohusiana na mipaka, umiliki, upangaji, au mambo mengine ya mali.'
          }
        ]
      }
    },
    'criminal-defense': {
      en: {
        title: 'Frequently Asked Questions',
        subtitle: 'Common questions about our criminal defense services',
        faqs: [
          {
            question: 'What should I do if I\'m arrested?',
            answer: 'Remain calm, exercise your right to remain silent, and request to contact your lawyer immediately. Do not make any statements without legal representation present. Contact us as soon as possible for immediate assistance.'
          },
          {
            question: 'How much does criminal defense representation cost?',
            answer: 'Costs vary depending on the complexity of the case, charges involved, and time required. We offer transparent pricing and flexible payment arrangements. Initial consultations help us provide accurate cost estimates.'
          },
          {
            question: 'Can charges be dropped or reduced?',
            answer: 'Yes, charges can sometimes be dropped or reduced through negotiation with prosecutors, challenging evidence, or demonstrating procedural violations. Our experienced team works aggressively to achieve the best possible outcome.'
          },
          {
            question: 'What happens during the bail application process?',
            answer: 'During bail application, we present arguments for your release pending trial, considering factors like flight risk, severity of charges, and community ties. We work to secure reasonable bail terms or release on personal bond.'
          },
          {
            question: 'How long do criminal cases typically take?',
            answer: 'Criminal cases can take anywhere from a few months to several years depending on complexity, court schedules, and whether the case goes to trial. We keep clients informed throughout the process and work to resolve cases efficiently.'
          }
        ]
      },
      sw: {
        title: 'Maswali Yanayoulizwa Mara Kwa Mara',
        subtitle: 'Maswali ya kawaida kuhusu huduma zetu za utetezi wa jinai',
        faqs: [
          {
            question: 'Nifanye nini kama nimekamatwa?',
            answer: 'Tulia, tumia haki yako ya kunyamaza, na omba kuwasiliana na mwanasheria wako mara moja. Usitoe taarifa yoyote bila uwakilishi wa kisheria kuwepo. Wasiliana nasi haraka iwezekanavyo kwa msaada wa haraka.'
          },
          {
            question: 'Uwakilishi wa utetezi wa jinai una gharama gani?',
            answer: 'Gharama zinatofautiana kulingana na utata wa kesi, mashtaka yanayohusika, na muda unaohitajika. Tunatoa bei wazi na mipango ya malipo ya kubadilika. Mazungumzo ya awali yanasaidia kutoa makadirio sahihi ya gharama.'
          },
          {
            question: 'Je, mashtaka yanaweza kufutwa au kupunguzwa?',
            answer: 'Ndiyo, mashtaka wakati mwingine yanaweza kufutwa au kupunguzwa kupitia mazungumzo na washtaki, kupinga ushahidi, au kuonyesha ukiukaji wa taratibu. Timu yetu yenye uzoefu inafanya kazi kwa ukali kufikia matokeo bora zaidi yanayowezekana.'
          },
          {
            question: 'Nini hufanyika wakati wa mchakato wa ombi la dhamana?',
            answer: 'Wakati wa ombi la dhamana, tunawasilisha hoja za kuachiliwa kwako ukisubiri jaribio, kuzingatia mambo kama hatari ya kukimbia, ukali wa mashtaka, na uhusiano wa jamii. Tunafanya kazi kupata masharti ya dhamana ya busara au kuachiliwa kwa dhamana ya kibinafsi.'
          },
          {
            question: 'Kesi za jinai kwa kawaida huchukua muda gani?',
            answer: 'Kesi za jinai zinaweza kuchukua mahali popote kutoka miezi michache hadi miaka kadhaa kulingana na utata, ratiba za mahakama, na kama kesi inaenda jaribio. Tunawajulisha wateja katika mchakato wote na kufanya kazi kutatua kesi kwa ufanisi.'
          }
        ]
      }
    }
  };

  const currentFAQ = faqData[practiceArea] || faqData['corporate-law'];
  const content = currentFAQ[currentLanguage];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-surface/5 to-primary/5">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            {content.title}
          </h2>
          <p className="text-lg text-text-secondary">
            {content.subtitle}
          </p>
        </div>

        <div className="space-y-4">
          {content.faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-border-light shadow-sm overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-surface/5 transition-colors duration-200 focus:outline-none focus:bg-surface/5"
              >
                <h3 className="text-lg font-heading font-semibold text-text-primary pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  <Icon
                    name={openFAQ === index ? "ChevronUp" : "ChevronDown"}
                    size={24}
                    className="text-primary transition-transform duration-200"
                  />
                </div>
              </button>
              
              {openFAQ === index && (
                <div className="px-8 pb-6 border-t border-border-light">
                  <p className="text-text-secondary leading-relaxed pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-2xl p-8 border border-border-light">
            <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
              {currentLanguage === 'en' ?'Still Have Questions?' :'Bado Una Maswali?'
              }
            </h3>
            <p className="text-text-secondary mb-6">
              {currentLanguage === 'en' ?'Contact us directly for personalized answers to your specific legal questions.' :'Wasiliana nasi moja kwa moja kwa majibu ya kibinafsi kwa maswali yako maalum ya kisheria.'
              }
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => {
                  const message = encodeURIComponent(currentLanguage === 'en' ?'Hello, I have some questions about your legal services.' :'Hujambo, nina maswali kuhusu huduma zenu za kisheria.');
                  window.open(`https://wa.me/254721320787?text=${message}`, '_blank');
                }}
                className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-xl font-medium hover:bg-accent transition-colors duration-200"
              >
                <Icon name="MessageCircle" size={20} className="mr-2" />
                {currentLanguage === 'en' ? 'Ask via WhatsApp' : 'Uliza kupitia WhatsApp'}
              </button>
              
              <button
                onClick={() => window.open('tel:+254721320787', '_self')}
                className="inline-flex items-center justify-center px-6 py-3 border border-primary text-primary rounded-xl font-medium hover:bg-primary hover:text-white transition-all duration-200"
              >
                <Icon name="Phone" size={20} className="mr-2" />
                {currentLanguage === 'en' ? 'Call Us' : 'Tupigie Simu'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;